import styles from "./traitsLeftBar.module.css";
import SquareCheckbox from "../../shared/inputs/SquareCheckbox";
import { useState } from "react";

type TraitsLeftBarProps = {
  traitTypeDefault?: string;
  setTraitType: (trait: string) => void;
  removeTraitType: (trait: string) => void;
  setDimension: (dimension: string) => void;
  removeDimension: (dimension: string) => void;
  setNature: (nature: string) => void;
  removeNature: (nature: string) => void;
  setArchetype: (archetype: string) => void;
  removeArchetype: (archetype: string) => void;
  defualtSelected: "element" | "pattern" | "archetype";
};

export default function TraitsLeftBar(props: TraitsLeftBarProps) {
  return (
    <div className={styles.leftBar}>
      <div className={styles.headingParent}>
        <h3 className={styles.filterHeading}>Trait Type</h3>
        <div className={styles.checkParent}>
          <SquareCheckbox
            defaultTrue={props.defualtSelected === "element" && true}
            setValue={(e) => {
              e === true && props.setTraitType("element");
              e === false && props.removeTraitType("element");
            }}
          />
          <h4>Elements</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            defaultTrue={props.defualtSelected === "pattern" && true}
            setValue={(e) => {
              e === true && props.setTraitType("pattern");
              e === false && props.removeTraitType("pattern");
            }}
          />
          <h4>Patterns</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            defaultTrue={props.defualtSelected === "archetype" && true}
            setValue={(e) => {
              e === true && props.setTraitType("archetype");
              e === false && props.removeTraitType("archetype");
            }}
          />
          <h4>Archetypes</h4>
        </div>
      </div>
      <div className={styles.headingParent}>
        <h3 className={styles.filterHeading}>Dimension</h3>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("personality-II");
              e === false && props.removeDimension("personality-II");
            }}
          />
          <h4>Cognition</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("personality");
              e === false && props.removeDimension("personality");
            }}
          />
          <h4>Primary Traits</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("values");
              e === false && props.removeDimension("values");
            }}
          />
          <h4>Values</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("communication-style");
              e === false && props.removeDimension("communication-style");
            }}
          />
          <h4>Interaction Styles</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("interests");
              e === false && props.removeDimension("interests");
            }}
          />
          <h4>Interests</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("attachment-style");
              e === false && props.removeDimension("attachment-style");
            }}
          />
          <h4>Attachment Styles</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("love-style");
              e === false && props.removeDimension("love-style");
            }}
          />
          <h4>Love Styles</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("love-attitudes");
              e === false && props.removeDimension("love-attitudes");
            }}
          />
          <h4>Love Attitudes</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("conflict-style");
              e === false && props.removeDimension("conflict-style");
            }}
          />
          <h4>Conflict Styles</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("strengths");
              e === false && props.removeDimension("strengths");
            }}
          />
          <h4>Strengths</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("lifestyle");
              e === false && props.removeDimension("lifestyle");
            }}
          />
          <h4>Lifestyle</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("sex-attitudes");
              e === false && props.removeDimension("sex-attitudes");
            }}
          />
          <h4>Sex Attitudes</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("political-ideology");
              e === false && props.removeDimension("political-ideology");
            }}
          />
          <h4>Political Ideology</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("secondary-traits");
              e === false && props.removeDimension("secondary-traits");
            }}
          />
          <h4>Secondary Traits</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setDimension("coping-style");
              e === false && props.removeDimension("coping-style");
            }}
          />
          <h4>Coping Styles</h4>
        </div>
      </div>

      <div className={styles.headingParent}>
        <h3 className={styles.filterHeading}>Nature</h3>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setNature("chaos");
              e === false && props.removeNature("chaos");
            }}
          />
          <h4>Passion & Sensitivity</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setNature("opennessAndIntellect");
              e === false && props.removeNature("opennessAndIntellect");
            }}
          />
          <h4>Openness & Curiosity</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setNature("warmthAndAgreeableness");
              e === false && props.removeNature("warmthAndAgreeableness");
            }}
          />
          <h4>Warmth & Agreeableness</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setNature("orderAndStructure");
              e === false && props.removeNature("orderAndStructure");
            }}
          />
          <h4>Order & Responsibility</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setNature("tranquility");
              e === false && props.removeNature("tranquility");
            }}
          />
          <h4>Tranquility</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setNature("energyAndExcitement");
              e === false && props.removeNature("energyAndExcitement");
            }}
          />
          <h4>Energy & Excitement</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setNature("selfEnhancement");
              e === false && props.removeNature("selfEnhancement");
            }}
          />
          <h4>Ambition & Self-Enhancement</h4>
        </div>
      </div>

      <div className={styles.headingParent}>
        <h3 className={styles.filterHeading}>Archetype Type</h3>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setArchetype("identity");
              e === false && props.removeArchetype("identity");
            }}
          />
          <h4>Cognition</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setArchetype("love");
              e === false && props.removeArchetype("love");
            }}
          />
          <h4>Love</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setArchetype("work");
              e === false && props.removeArchetype("work");
            }}
          />
          <h4>Interaction</h4>
        </div>
        <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setArchetype("career");
              e === false && props.removeArchetype("career");
            }}
          />
          <h4>Career</h4>
        </div>
        {/* <div className={styles.checkParent}>
          <SquareCheckbox
            setValue={(e) => {
              e === true && props.setArchetype("values");
              e === false && props.removeArchetype("values");
            }}
          />
          <h4>Values</h4>
        </div> */}
      </div>
    </div>
  );
}
